import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { cn } from '../lib/classNames.js';

import { BookmarkIcon, ChatIcon, ClockIcon, SettingsIcon, ToolsIcon } from './icons/Icon.js';

type Tab = { to: string; label: string; icon: ReactNode };

const tabs: Tab[] = [
  { to: '/', label: 'Chat', icon: <ChatIcon /> },
  { to: '/tools', label: 'Tools', icon: <ToolsIcon /> },
  { to: '/history', label: 'History', icon: <ClockIcon /> },
  { to: '/library', label: 'Library', icon: <BookmarkIcon /> },
  { to: '/settings', label: 'Settings', icon: <SettingsIcon /> },
];

export const BottomNav = () => (
  <nav
    aria-label="Primary"
    className="sticky bottom-0 z-10 grid grid-cols-5 gap-1 border-t border-ink/[0.06] bg-canvas/90 px-2 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2 backdrop-blur"
  >
    {tabs.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.to === '/'}
        className={({ isActive }) =>
          cn(
            'flex flex-col items-center justify-center gap-1 rounded-xl py-1.5 text-[10px] font-medium transition',
            isActive ? 'text-accent bg-accent/10' : 'text-ink-muted hover:text-ink hover:bg-ink/5',
          )
        }
      >
        <span aria-hidden className="grid place-items-center">
          {tab.icon}
        </span>
        <span className="tracking-wide">{tab.label}</span>
      </NavLink>
    ))}
  </nav>
);
